import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { DateTimeFormatOptions } from 'luxon'
import Markdown from 'marked-react'
import LazyHydrate from 'react-lazy-hydration'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { HeadingLG, ParagraphLG } from '@/atoms/Text'
import { press } from '@/constants/press'
import { PressHeader } from '@/organisms/PressHeader'
import { options, renderer } from '@/services/ContentfulService'
import { PressRelease } from '@/services/PressService'

interface PressReleaseViewProps {
  pressRelease: PressRelease
}

export const PressReleaseView: React.FC<PressReleaseViewProps> = ({ pressRelease }) => {
  const formatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  } as DateTimeFormatOptions

  const publishedDate = new Date(pressRelease.publishDate ?? pressRelease.sys.firstPublishedAt)
  const modifiedDate = new Date(pressRelease.sys.publishedAt)

  const formattedPublishDate = publishedDate.toLocaleDateString('en-US', formatOptions)
  const formattedModifiedDate = modifiedDate.toLocaleDateString('en-US', formatOptions)

  const modified = formattedPublishDate !== formattedModifiedDate

  const headliner = `${pressRelease.location ?? press.location}—${formattedPublishDate}${
    modified ? `—Updated ${formattedModifiedDate}` : ''
  }`

  const logo = pressRelease?.project?.logo?.[0]
    ? `v${pressRelease.project.logo[0].version}/${pressRelease.project.logo[0].public_id}.webp`
    : 'v1695393762/angel-studios/logos/Angel-Studios-Logo-Copper.svg'

  return (
    <div className="bg-white pt-16">
      <PressHeader logo={logo} />
      <LazyHydrate whenVisible>
        <PaddedContainer>
          <main className="py-4">
            <div className="mt-10 text-center">
              <HeadingLG>{pressRelease.title}</HeadingLG>
              {pressRelease.excerpt && (
                <div className="my-10 text-core-gray-500">
                  <Markdown renderer={renderer}>{pressRelease.excerpt}</Markdown>
                </div>
              )}
            </div>
            <ParagraphLG className="mb-4">{headliner}</ParagraphLG>
            {documentToReactComponents(pressRelease.body?.json, options)}
          </main>
        </PaddedContainer>
      </LazyHydrate>
    </div>
  )
}
